document.querySelectorAll('.product__accordion').forEach((accordion) => {

  const trigger = accordion.querySelector('.accordion__trigger');
  const content = accordion.querySelector('.accordion__content');
  const inner = accordion.querySelector('.accordion__content-inner');

  trigger.addEventListener('click', () => {

    const isOpen = accordion.classList.contains('is-open');

    if (isOpen) {

      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      accordion.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

    } else {

      content.style.height = inner.scrollHeight + 'px';

      accordion.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      const onTransitionEnd = () => {
        content.style.height = 'auto';
        content.removeEventListener('transitionend', onTransitionEnd);
      };

      content.addEventListener('transitionend', onTransitionEnd);

    }

  });

});
